<template>
  <b-row>
    <b-col cols="12">
      <span class="float-left h6">{{$t("views.agreements.form.agreementsPromotions")}}: </span>
    </b-col>
    <b-col>
      <template v-if="data.agreementPromotions && data.agreementPromotions.length > 0">
        <b-row v-for="(item, index) in data.agreementPromotions" :key="index">
          <div class="text-center d-md-inline-block align-self-center ml-3">
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removePromotion(index)"
              v-b-tooltip :title="$t('buttons.delete')">
            </button>
          </div>
          <b-col md="4">
            <model-select v-model="data.agreementPromotions[index].promotion" :options="promotionsOptions" :placeholder="$t('views.agreements.form.select')" required class="mb-1 mt-2" name="item">
            </model-select>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <b-button class="btn float-left btn-primary" @click="addNewPromotion()">{{ $t('views.agreements.form.addNewPromotion') }}</b-button>
        </b-col>
      </b-row>
      <hr class="my-1">
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import remove from '@/utils/remove'

export default {
  name: 'AgreementPromotions',
  components: {
    ModelSelect
  },

  props: ['data', 'violations', 'promotionsFromAgreement'],

  computed: {
    ...mapGetters({
      getPromotions: 'agreements/list/getPromotions'
    }),
    promotionsOptions () {
      if (this.promotionsFromAgreement) {
        return this.promotionsFromAgreement
      }
      return this.getPromotions
    }
  },

  created () {
    this.fetchPromotions()
  },

  methods: {
    addNewPromotion () {
      let item = {}
      this.data.agreementPromotions.push(item)
    },
    removePromotion (index) {
      let currentPromotion = this.data.agreementPromotions[index]
      if (currentPromotion['@id']) {
        remove(currentPromotion['@id'], () => {
          this.data.agreementPromotions.splice(index, 1)
          this.data.originalAgreementPromotions = JSON.stringify(this.data.agreementPromotions)
        })
      } else {
        this.data.agreementPromotions.splice(index, 1)
      }
    },
    fetchPromotions () {
      if (this.promotionsFromAgreement) {
        return
      }
      this.fetchPromotionsForAgreement()
    },
    ...mapActions({
      fetchPromotionsForAgreement: 'agreements/list/fetchPromotions'
    })
  }
}
</script>
